/*
 * File: CurrentUsers.styles.js
 * Project: lets-talk-web
 *
 * Copied from Profile.styles.js
 */

/**
 * Imports
 */

// Modules
import styled from 'styled-components';

// Components
import { Padding } from '../../../components';

// Constants
import { mobileBreakpoint } from '../../../styles/constants';


/**
 * Styles
 */

export const Wrapper = styled(Padding)`
	position: relative;
	width: 100%;
	flex-direction: column;
	padding-top: 40px;
	padding-bottom: 40px;
`;

export const Decoration = styled.div`
	position: absolute;
	z-index: 1;
	width: 100%;
	min-height: 70vw;
	height: 100vh;
	left: 0px;
	top: 0px;
	background-image: url('${process.env.CDN_URL}/public/assets/decorations/green-bump-decoration.png');
	background-size: cover;
	background-position: 50% 0%;
	background-repeat: no-repeat;
`;

export const TitleWidget = styled.div`
	width: 100%;
	height: 62px;
	border-radius: 100px;
	border: 2px solid ${({ theme }) => theme.brandSecondaryBaseDarker};
	display: flex;
	align-items: center;
	z-index: 2;
	flex-shrink: 0;

	h4 {
		color: ${({ theme }) => theme.brandSecondaryBaseDarker};
		text-align: left;
		margin-left: 30px;
	}
`;

export const ContentContainer = styled.div`
	height: 100%;
	text-align: left;
	z-index: 2;
	margin-bottom: 100px;
`;

export const Header = styled.div`
	margin: 30px 0px 0px;
	width: 100%;
	max-width: 100%;

	* {
		text-align: left;
		line-height: 1.6;
	}
	@media only screen and (min-width: ${mobileBreakpoint}em) {
		max-width: 75%;
	}
`;
